import Close from '@mui/icons-material/Close';
import { Box, IconButton, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { JSX } from 'react';

import { ButtonConfig, Steps } from '../../types';
import ButtonsList from '../ButtonsList';
import { styles } from './styles';

interface HeaderProps {
  onClose: () => any;
  buttons: ButtonConfig[];
  actions?: string[];
  title?: string;
  icons?: JSX.Element[];
  captureState?: Steps;
}

const Header = ({ buttons, icons = [], title = '', onClose, captureState }: HeaderProps) => {
  const theme = useTheme();
  const sx = styles(theme, buttons.length, captureState === Steps.Photo);

  return (
    <Box sx={sx.container}>
      <Box display="flex" alignItems="center" gap={2}>
        <Box sx={sx.iconBox}>
          <IconButton onClick={onClose} aria-label="Close">
            <Close style={sx.icon} />
          </IconButton>
        </Box>
        {title && (
          <Typography sx={sx.title} fontWeight="bold" color="white">
            {title}
          </Typography>
        )}
      </Box>

      <Box sx={sx.actions}>
        {icons.map((icon) => icon)}
        <Box sx={sx.mobileDesktopButton}>
          <Box sx={sx.groupButton}>
            <ButtonsList buttons={buttons} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Header;
